import { NgModule } from '@angular/core';
import { UnsupportedBrowserComponent } from './unsupported-browser.component';
import { BrowserModule } from '@angular/platform-browser';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AngularSvgIconPreloaderModule } from 'angular-svg-icon-preloader';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [UnsupportedBrowserComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    AngularSvgIconPreloaderModule.forRoot({
      configUrl: './assets/preload-icons.json'
    })
  ],
  bootstrap: [UnsupportedBrowserComponent]
})
export class UnsupportedBrowserModule {}
